import { PieChartData } from 'utils/types'

export enum SummaryTitles {
  employees = 'Total Employees',
  companies = 'Total Companies',
  industries = 'Total Industries',
}

export interface SummaryCompanies {
  title: SummaryTitles.companies
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}

export interface SummaryIndustries {
  title: SummaryTitles.employees
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}

export interface SummaryEmployees {
  title: SummaryTitles.employees
  pieChartData: PieChartData[]
  total: number
  moreResultsCount: number
}

export interface ICompanySummary {
  companies: SummaryCompanies
  industries: SummaryIndustries
  employees: SummaryEmployees
}
